import {
  ALERTS_MANAGER_AVAILABLE,
  DAY_DEPTH_AVAILABLE,
  DIRECTIONAL_DRILLING_AVAILABLE,
  DRILLING_MULTI_ANALYSIS_AVAILABLE,
  HEATMAP_AVAILABLE,
  IMAGE_BROADCAST_AVAILABLE,
  OPERATIONAL_PARAMETERS_AVAILABLE,
  TRAJECTORY_AVAILABLE,
  VIDEOBROADCAST_AVAILABLE,
  WELL_ANALYSE_AVAILABLE,
  WELL_CORRELATION_AVAILABLE,
} from 'src/api/consts';

import type { TWidgetType, TWidgetTypeGroup } from './NewContentWidgetModal.store';

const wellAnalyseWidgetGroup: TWidgetType = {
  type: 'well-analyse-widget',
  name: 'widgets:WellAnalyse.title',
  description: 'widgets:WellAnalyse.description',
  iconsMap: [['analyze'], ['empty', 'empty']],
};

const dayDepthWidgetGroup: TWidgetType = {
  type: 'time-vs-depth-widget',
  name: 'widgets:DayDepth.title',
  description: 'widgets:DayDepth.description',
  iconsMap: [['day-vs-depth'], ['empty', 'empty']],
};

const imageBroadcastWidgetGroup: TWidgetType = {
  type: 'image-broadcast-widget',
  name: 'widgets:ImageBroadcast.title',
  description: 'widgets:ImageBroadcast.description',
  iconsMap: [['broadcast'], ['empty', 'empty']],
};

const directionalDrillingWidgetGroup: TWidgetType = {
  type: 'directional-drilling-widget',
  name: 'widgets:DirectionalDrilling.title',
  description: 'widgets:DirectionalDrilling.description',
  iconsMap: [['directional'], ['empty', 'empty']],
};

const videobroadcastWidgetGroup: TWidgetType = {
  type: 'videobroadcast-widget',
  name: 'widgets:VideoBroadcast.title',
  description: 'widgets:VideoBroadcast.description',
  iconsMap: [['video'], ['empty', 'empty']],
};

const heatmapWidgetGroup: TWidgetType = {
  type: 'heatmap-widget',
  name: 'widgets:Heatmap.title',
  description: 'widgets:Heatmap.description',
  iconsMap: [['heatmap'], ['empty', 'empty']],
};

const drillingMultiAnalysisWidgetGroup: TWidgetType = {
  type: 'drilling-multi-analysis-widget',
  name: 'widgets:DrillingMultiAnalysis.title',
  description: 'widgets:DrillingMultiAnalysis.description',
  iconsMap: [['drilling-multi-analysis'], ['empty', 'empty']],
};

const AlertsManagerWidgetGroup: TWidgetType = {
  type: 'alerts-manager-widget',
  name: 'widgets:AlertsManager.title',
  description: 'widgets:AlertsManager.description',
  iconsMap: [['alerts-manager'], ['empty', 'empty']],
};

const WellCorrelationWidgetGroup: TWidgetType = {
  type: 'well-correlation-widget',
  name: 'widgets:WellCorrelation.title',
  description: 'widgets:WellCorrelation.description',
  iconsMap: [['well-correlation'], ['empty', 'empty']],
};

const TrajectoryWidgetGroup: TWidgetType = {
  type: 'trajectory-widget',
  name: 'widgets:Trajectory.title',
  description: 'widgets:Trajectory.description',
  iconsMap: [['empty'], ['empty', 'empty']],
};

const widgetsOperationalParamsGroups: TWidgetTypeGroup[] = [
  {
    type: 'operationalParams',
    name: 'widgets:OperationalParams.title',
    description: 'widgets:OperationalParams.description',
    iconsMap: [['operational'], ['clock', 'vertArrow']],
    widgets: [
      {
        type: 'well-operational-params-widget',
        wellIndexType: 'LOG_TIME',
        name: 'modals:CreateContentWidget.generalTime',
        description: 'modals:CreateContentWidget.operationalParamsTime',
        iconsMap: [['clock'], ['operational']],
      },
      {
        type: 'well-operational-params-widget',
        wellIndexType: 'LOG_DEPTH',
        name: 'modals:CreateContentWidget.generalDepth',
        description: 'modals:CreateContentWidget.operationalParamsDepth',
        iconsMap: [['depth'], ['operational']],
      },
    ],
  },
];

const widgetsGroups: TWidgetTypeGroup[] = [
  {
    type: 'dataFromSensors',
    name: 'modals:CreateContentWidget.sensorsData',
    description: 'modals:CreateContentWidget.rtAndHistorical',
    iconsMap: [['graph'], ['clock', 'vertArrow']],
    widgets: [
      {
        type: 'well-logs-widget',
        wellIndexType: 'LOG_TIME',
        name: 'modals:CreateContentWidget.generalTime',
        description: 'modals:CreateContentWidget.generalTimeSensors',
        iconsMap: [['clock'], ['graph']],
      },
      {
        type: 'well-logs-widget',
        wellIndexType: 'LOG_DEPTH',
        name: 'modals:CreateContentWidget.generalDepth',
        description: 'modals:CreateContentWidget.generalDepthSensors',
        iconsMap: [['depth'], ['graph']],
      },
    ],
  },
];

const filteredWidgetsGroups: (TWidgetType | TWidgetTypeGroup)[] = [...widgetsGroups];

if (OPERATIONAL_PARAMETERS_AVAILABLE) {
  filteredWidgetsGroups.push(...widgetsOperationalParamsGroups);
}

if (DIRECTIONAL_DRILLING_AVAILABLE) {
  filteredWidgetsGroups.push(directionalDrillingWidgetGroup);
}

if (WELL_ANALYSE_AVAILABLE) {
  filteredWidgetsGroups.push(wellAnalyseWidgetGroup);
}

if (IMAGE_BROADCAST_AVAILABLE) {
  filteredWidgetsGroups.push(imageBroadcastWidgetGroup);
}

if (VIDEOBROADCAST_AVAILABLE) {
  filteredWidgetsGroups.push(videobroadcastWidgetGroup);
}

if (DAY_DEPTH_AVAILABLE) {
  filteredWidgetsGroups.push(dayDepthWidgetGroup);
}

if (HEATMAP_AVAILABLE) {
  filteredWidgetsGroups.push(heatmapWidgetGroup);
}

if (DRILLING_MULTI_ANALYSIS_AVAILABLE) {
  filteredWidgetsGroups.push(drillingMultiAnalysisWidgetGroup);
}

if (ALERTS_MANAGER_AVAILABLE) {
  filteredWidgetsGroups.push(AlertsManagerWidgetGroup);
}

if (WELL_CORRELATION_AVAILABLE) {
  filteredWidgetsGroups.push(WellCorrelationWidgetGroup);
}

if (TRAJECTORY_AVAILABLE) {
  filteredWidgetsGroups.push(TrajectoryWidgetGroup);
}

export { filteredWidgetsGroups as widgetsGroups };
